/**
 * Safe labels for admin Contributions rows.
 * Missing/null fields must never crash the dashboard render.
 */

import { fmtUSDprecise, timeAgo } from "@/lib/format";

export function adminContributionTxLabel(transactionHash) {
  if (typeof transactionHash === "string" && transactionHash.length > 0) {
    return `${transactionHash.slice(0, 16)}…`;
  }
  return "No tx hash";
}

export function formatAdminContributionRow(c = {}) {
  const wallet = c.wallet_short || "—";
  const token = c.payment_token_symbol || "—";
  const txLabel = adminContributionTxLabel(c.transaction_hash);
  const status = c.status || "unknown";
  const when = timeAgo(c.created_at) || "—";
  const usdLabel = fmtUSDprecise(c.usd_value);

  return {
    id: c.id,
    wallet,
    token,
    primary: `${wallet} → ${token}`,
    secondary: `${txLabel} · ${status} · ${when}`,
    txLabel,
    status,
    when,
    usdLabel,
  };
}
